/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.Company = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The Company model module.
   * @module model/Company
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>Company</code>.
   * @alias module:model/Company
   * @class
   */
  var exports = function() {
    var _this = this;




























  };

  /**
   * Constructs a <code>Company</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/Company} obj Optional instance to populate.
   * @return {module:model/Company} The populated <code>Company</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('OrganizationId')) {
        obj['OrganizationId'] = ApiClient.convertToType(data['OrganizationId'], 'String');
      }
      if (data.hasOwnProperty('IsDemoCompany')) {
        obj['IsDemoCompany'] = ApiClient.convertToType(data['IsDemoCompany'], 'Integer');
      }
      if (data.hasOwnProperty('FixedMonthlyServicePrice')) {
        obj['FixedMonthlyServicePrice'] = ApiClient.convertToType(data['FixedMonthlyServicePrice'], 'Number');
      }
      if (data.hasOwnProperty('AgreementSigned')) {
        obj['AgreementSigned'] = ApiClient.convertToType(data['AgreementSigned'], 'Date');
      }
      if (data.hasOwnProperty('CompanyTemplateTypeID')) {
        obj['CompanyTemplateTypeID'] = ApiClient.convertToType(data['CompanyTemplateTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('FromPartnerID')) {
        obj['FromPartnerID'] = ApiClient.convertToType(data['FromPartnerID'], 'Integer');
      }
      if (data.hasOwnProperty('PartnerSupportLevelID')) {
        obj['PartnerSupportLevelID'] = ApiClient.convertToType(data['PartnerSupportLevelID'], 'Integer');
      }
      if (data.hasOwnProperty('CostCenter')) {
        obj['CostCenter'] = ApiClient.convertToType(data['CostCenter'], 'String');
      }
      if (data.hasOwnProperty('BillingDetails')) {
        obj['BillingDetails'] = ApiClient.convertToType(data['BillingDetails'], 'String');
      }
      if (data.hasOwnProperty('ProductPackageID')) {
        obj['ProductPackageID'] = ApiClient.convertToType(data['ProductPackageID'], 'Integer');
      }
      if (data.hasOwnProperty('Advisory360ServiceLevelID')) {
        obj['Advisory360ServiceLevelID'] = ApiClient.convertToType(data['Advisory360ServiceLevelID'], 'Integer');
      }
      if (data.hasOwnProperty('BillingMinimumUsers')) {
        obj['BillingMinimumUsers'] = ApiClient.convertToType(data['BillingMinimumUsers'], 'Integer');
      }
      if (data.hasOwnProperty('BillingCorporateCalculationOn')) {
        obj['BillingCorporateCalculationOn'] = ApiClient.convertToType(data['BillingCorporateCalculationOn'], 'Boolean');
      }
      if (data.hasOwnProperty('BillingCustomAPI')) {
        obj['BillingCustomAPI'] = ApiClient.convertToType(data['BillingCustomAPI'], 'Boolean');
      }
      if (data.hasOwnProperty('BillingSeveraIntegration')) {
        obj['BillingSeveraIntegration'] = ApiClient.convertToType(data['BillingSeveraIntegration'], 'Boolean');
      }
      if (data.hasOwnProperty('PricingUserDiscountPercentage')) {
        obj['PricingUserDiscountPercentage'] = ApiClient.convertToType(data['PricingUserDiscountPercentage'], 'Number');
      }
      if (data.hasOwnProperty('CompanyContractMainUserID')) {
        obj['CompanyContractMainUserID'] = ApiClient.convertToType(data['CompanyContractMainUserID'], 'Integer');
      }
      if (data.hasOwnProperty('CompanyTechnicalMainUserID')) {
        obj['CompanyTechnicalMainUserID'] = ApiClient.convertToType(data['CompanyTechnicalMainUserID'], 'Integer');
      }
      if (data.hasOwnProperty('BillingFinancialToolsOn')) {
        obj['BillingFinancialToolsOn'] = ApiClient.convertToType(data['BillingFinancialToolsOn'], 'Integer');
      }
      if (data.hasOwnProperty('AlternativeBillingCompanyID')) {
        obj['AlternativeBillingCompanyID'] = ApiClient.convertToType(data['AlternativeBillingCompanyID'], 'Integer');
      }
      if (data.hasOwnProperty('AskForAgreementSigning')) {
        obj['AskForAgreementSigning'] = ApiClient.convertToType(data['AskForAgreementSigning'], 'Boolean');
      }
      if (data.hasOwnProperty('AnonymizeInterComInformation')) {
        obj['AnonymizeInterComInformation'] = ApiClient.convertToType(data['AnonymizeInterComInformation'], 'Boolean');
      }
      if (data.hasOwnProperty('DisableHotjar')) {
        obj['DisableHotjar'] = ApiClient.convertToType(data['DisableHotjar'], 'Boolean');
      }
      if (data.hasOwnProperty('EncryptUserData')) {
        obj['EncryptUserData'] = ApiClient.convertToType(data['EncryptUserData'], 'Boolean');
      }
      if (data.hasOwnProperty('EmailDeliveryChannelID')) {
        obj['EmailDeliveryChannelID'] = ApiClient.convertToType(data['EmailDeliveryChannelID'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {String} OrganizationId
   * @default ''
   */
  exports.prototype['OrganizationId'] = '';
  /**
   * @member {Integer} IsDemoCompany
   * @default 0
   */
  exports.prototype['IsDemoCompany'] = 0;
  /**
   * @member {Number} FixedMonthlyServicePrice
   * @default 0.0
   */
  exports.prototype['FixedMonthlyServicePrice'] = 0.0;
  /**
   * @member {Date} AgreementSigned
   */
  exports.prototype['AgreementSigned'] = undefined;
  /**
   * @member {Integer} CompanyTemplateTypeID
   * @default 0
   */
  exports.prototype['CompanyTemplateTypeID'] = 0;
  /**
   * @member {Integer} FromPartnerID
   * @default 0
   */
  exports.prototype['FromPartnerID'] = 0;
  /**
   * @member {Integer} PartnerSupportLevelID
   * @default 0
   */
  exports.prototype['PartnerSupportLevelID'] = 0;
  /**
   * @member {String} CostCenter
   * @default ''
   */
  exports.prototype['CostCenter'] = '';
  /**
   * @member {String} BillingDetails
   * @default ''
   */
  exports.prototype['BillingDetails'] = '';
  /**
   * @member {Integer} ProductPackageID
   * @default 0
   */
  exports.prototype['ProductPackageID'] = 0;
  /**
   * @member {Integer} Advisory360ServiceLevelID
   * @default 0
   */
  exports.prototype['Advisory360ServiceLevelID'] = 0;
  /**
   * @member {Integer} BillingMinimumUsers
   * @default 0
   */
  exports.prototype['BillingMinimumUsers'] = 0;
  /**
   * @member {Boolean} BillingCorporateCalculationOn
   * @default false
   */
  exports.prototype['BillingCorporateCalculationOn'] = false;
  /**
   * @member {Boolean} BillingCustomAPI
   * @default false
   */
  exports.prototype['BillingCustomAPI'] = false;
  /**
   * @member {Boolean} BillingSeveraIntegration
   * @default false
   */
  exports.prototype['BillingSeveraIntegration'] = false;
  /**
   * @member {Number} PricingUserDiscountPercentage
   * @default 0.0
   */
  exports.prototype['PricingUserDiscountPercentage'] = 0.0;
  /**
   * @member {Integer} CompanyContractMainUserID
   * @default 0
   */
  exports.prototype['CompanyContractMainUserID'] = 0;
  /**
   * @member {Integer} CompanyTechnicalMainUserID
   * @default 0
   */
  exports.prototype['CompanyTechnicalMainUserID'] = 0;
  /**
   * @member {Integer} BillingFinancialToolsOn
   * @default 0
   */
  exports.prototype['BillingFinancialToolsOn'] = 0;
  /**
   * @member {Integer} AlternativeBillingCompanyID
   * @default 0
   */
  exports.prototype['AlternativeBillingCompanyID'] = 0;
  /**
   * @member {Boolean} AskForAgreementSigning
   * @default false
   */
  exports.prototype['AskForAgreementSigning'] = false;
  /**
   * @member {Boolean} AnonymizeInterComInformation
   * @default false
   */
  exports.prototype['AnonymizeInterComInformation'] = false;
  /**
   * @member {Boolean} DisableHotjar
   * @default false
   */
  exports.prototype['DisableHotjar'] = false;
  /**
   * @member {Boolean} EncryptUserData
   * @default false
   */
  exports.prototype['EncryptUserData'] = false;
  /**
   * @member {Integer} EmailDeliveryChannelID
   * @default 0
   */
  exports.prototype['EmailDeliveryChannelID'] = 0;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


